export default class GuitarStrings {
  init() {
    var canvas = document.getElementById("string");
    var ctx = canvas.getContext("2d");
    canvas.width = document.getElementById("string").parentElement.clientWidth;
    canvas.height = document.getElementById("string").parentElement.clientHeight;
    var width = canvas.clientWidth;
    var height = canvas.clientHeight;

    window.addEventListener("resize", setWindowSize);

    function setWindowSize() {
      canvas.width = document.getElementById("string").parentElement.clientWidth;
      canvas.height = document.getElementById("string").parentElement.clientHeight;
      width = canvas.clientWidth;
      height = canvas.clientHeight;
      string1 = new StringMelody(0.1);
      string2 = new StringMelody(0.2);
      string3 = new StringMelody(0.3);
      string4 = new StringBass(0.1);
      string5 = new StringBass(0.2);
      string6 = new StringBass(0.3);
    }

    ctx.strokeStyle = "black";

    const StringMelody = function (numbPos) {
      this.mid = Math.round(height / 2);
      this.angel = 0;
      this.amplitude = 30;
      this.status = false;
      this.totalVoidArea = height * 0.4;
      this.voidTopArea = height * 0.15;
      this.voidBottomArea = height * 0.2;
      this.stringArea = (height - this.totalVoidArea) / 6;
      this.stringPos = numbPos * height;
      this.s = this.voidTopArea + this.stringPos - this.stringArea / 2;
      this.stringTA = this.s - this.stringArea / 2;
      this.StringDumpingPos = 0;
    };
    StringMelody.prototype = {
      dumping: function (firstTime) {
        if (this.status === true || firstTime === true) {
          this.StringDumpingPos = this.amplitude * Math.sin(this.angel);
          this.angel += 0.9;
          this.amplitude *= 0.98;
          if (this.amplitude < 0.5) {
            this.status = false;
            this.amplitude = 30;
          }
        }
      },
      line: function () {
        ctx.beginPath();
        ctx.moveTo(0, this.s);
        ctx.bezierCurveTo(
          100,
          this.s + this.StringDumpingPos,
          width - 100,
          this.s + this.StringDumpingPos,
          width,
          this.s
        );
        ctx.stroke();
        ctx.closePath();
      },
      checkP: function (position, firstTime) {
        if (
          (position >= this.stringTA &&
          position <= this.stringTA + this.stringArea) || firstTime === true
        ) {
          this.status = true;
          this.amplitude = 30;
        }
      },
    };

    const StringBass = function (numbPos) {
      this.mid = Math.round(height / 2);
      this.angel = 0;
      this.amplitude = 50;
      this.status = false;
      this.totalVoidArea = height * 0.4;
      this.voidBottomArea = height - height * 0.25;
      this.stringArea = (height - this.totalVoidArea) / 6;
      this.stringPos = numbPos * height;
      this.s = this.voidBottomArea - this.stringPos + this.stringArea / 2;
      this.stringTA = this.s - this.stringArea / 2;
      this.StringDumpingPos = 0;
    };
    StringBass.prototype = {
      dumping: function (firstTime) {
        if (this.status === true || firstTime === true) {
          this.StringDumpingPos = this.amplitude * Math.sin(this.angel);
          this.angel += 0.9;
          this.amplitude *= 0.98;
          if (this.amplitude < 0.5) {
            this.status = false;
            this.amplitude = 30;
          }
        }
      },
      line: function () {
        ctx.beginPath();
        ctx.moveTo(0, this.s);
        ctx.bezierCurveTo(
          100,
          this.s + this.StringDumpingPos,
          width - 100,
          this.s + this.StringDumpingPos,
          width,
          this.s
        );
        ctx.stroke();
        ctx.closePath();
      },
      checkP: function (position, firstTime) {
        if (
          (position >= this.stringTA &&
          position <= this.stringTA + this.stringArea) || firstTime === true
        ) {
          this.status = true;
          this.amplitude = 30;
        }
      },
    };
    
    window.addEventListener("mousemove", function (e) {
      this.position = getCursorPosition(canvas, e);
      string1.checkP(this.position);
      string2.checkP(this.position);
      string3.checkP(this.position);
      string4.checkP(this.position);
      string5.checkP(this.position);
      string6.checkP(this.position);
    });

    window.addEventListener("touchmove", function (e) {
      this.position = getCursorPosition(canvas, e);
      string1.checkP(this.position);
      string2.checkP(this.position);
      string3.checkP(this.position);
      string4.checkP(this.position);
      string5.checkP(this.position);
      string6.checkP(this.position);
    });

    var string1 = new StringMelody(0.1);
    var string2 = new StringMelody(0.2);
    var string3 = new StringMelody(0.3);
    var string4 = new StringBass(0.1);
    var string5 = new StringBass(0.2);
    var string6 = new StringBass(0.3);

    var firstTime = false;

    window.addEventListener("click", function (e) {
      firstTime = false;
    });

    window.addEventListener("load", function (e) {
      this.position = getCursorPosition(canvas, e);
      firstTime = true;

      string1.checkP(position, firstTime);
      setTimeout(function(){
        string2.checkP(position, firstTime);
        setTimeout(function(){
          string3.checkP(position, firstTime);
          setTimeout(function(){
            string6.checkP(position, firstTime);
            setTimeout(function(){
              string5.checkP(position, firstTime);
              setTimeout(function(){
                string4.checkP(position, firstTime);
                firstTime = false;
              }, 1000)
            }, 1000);
          }, 1000);
        }, 1000);
      }, 1000);

    });

    function getCursorPosition(canvas, event) {
      const rect = canvas.getBoundingClientRect();
      const y = event.clientY - rect.top;
      return y;
    }

    function loop() {
      requestAnimationFrame(loop);
      ctx.clearRect(0, 0, width, height);
      string1.dumping();
      string2.dumping();
      string3.dumping();
      string4.dumping();
      string5.dumping();
      string6.dumping();

      string1.line();
      string2.line();
      string3.line();
      string4.line();
      string5.line();
      string6.line();
    }

    loop();
  }
}
